/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import DatePicker from "react-datepicker";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

import MDCard from "components/MDCard";
// Functions from store
import {
  createDynamicColumn,
  downloadMinMaxFailure,
  getDynamicColumn,
  getItemMaster,
  getItemStatus,
  getItemTypesForStatus,
  getLocations,
  getMinMaxFailure,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";
import TextError from "utils/TextError";

import { addDays, addMinutes, format, subDays } from "date-fns";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const MinMaxFailure = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getItemTypesForStatus,
  itemMaster,
  createDynamicColumn,
  getDynamicColumn,
  getItemStatusReducer,
  getLocations,
  getLocationsReducer,
  downloadMinMaxFailure,
  getMinMaxFailure,
  getMinMaxFailureReducer,
  downloadMinMaxFailureReportReducer,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 400, md: 520 },
    maxHeight: "90vh",
    // Remove or adjust overflowY
    // overflowY: "visible",
    boxShadow: 24,
    p: 2,
    bgcolor: "background.paper",
    borderRadius: 3,
    zIndex: 1400,
  };
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedItemType, setSelectedItemType] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [Download, setDownload] = useState("");
  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  useEffect(() => {
    getItemTypesForStatus(jwtToken);
  }, []);

  useEffect(() => {
    getLocations(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let itemStatusReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "95815117-55fd-40be-ab8f-a9407d9ae1df",
  );

  let viewItemStatus = itemStatusReportModule
    ? itemStatusReportModule.actionId.includes(
        "e7b51078-d27b-4bf2-9707-efa327848bad",
      )
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Transaction Code", accessor: "transactionCode" },
      {
        Header: "Item Code",
        accessor: "itemCode",
      },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      { Header: "Picklist Qty", accessor: "picklistQty" },
      { Header: "QTY", accessor: "qty" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempMinMax = [];
    let data = getMinMaxFailureReducer.minMax.data
      ? getMinMaxFailureReducer.minMax.data
      : [];

    let getMinMaxFailureReducerz = getMinMaxFailureReducer;

    setLoading(getMinMaxFailureReducer.loading);

    setPaginationObj(getMinMaxFailureReducer.minMax?.pagination);
    data?.map((minMax) => {
      let des = minMax?.itemDescription;
      let len = desLength;
      const formatDate = new Date(minMax.cd);
      const minMaxObject = {
        transactionCode: minMax.transactionCode,

        itemCode: `${minMax.itemCode}`,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {minMax?.itemDescription?.length > 35 ? (
              <Tooltip
                title={minMax.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {minMax.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {minMax.itemDescription}
              </MDTypography>
            )}
            {minMax?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: minMax.cd,
        picklistQty: minMax.picklistQty,

        qty: `${minMax.qty}`,
        uom: ` ${minMax.uom}`,
      };
      tempMinMax.push(minMaxObject);
    });
    // viewFG &&
    setState({ ...state, rows: tempMinMax });
  }, [getMinMaxFailureReducer]);

  useEffect(() => {
    let tempMinMax = [];
    let data = downloadMinMaxFailureReportReducer.minMax.data
      ? downloadMinMaxFailureReportReducer.minMax.data
      : [];

    data?.map((minMax) => {
      let des = minMax?.itemDescription;
      let len = desLength;
      const formatDate = new Date(minMax.cd);
      const minMaxObject = {
        trCode: minMax.transactionCode,
        itemCode: `${minMax.itemCode}`,

        itemDescription: `${minMax.itemDescription}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: minMax.cd,
        picklistQty: minMax.picklistQty,

        qty: `${minMax.qty}`,
        uom: ` ${minMax.uom}`,
      };
      tempMinMax.push(minMaxObject);
    });
    // viewFG &&
    setDownload(tempMinMax);
  }, [downloadMinMaxFailureReportReducer]);

  const headers = [
    {
      label: "Transaction Code",
      key: "trCode",
    },
    { label: "ItemCode", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Picklist Qty", key: "picklistQty" },
    {
      label: "Qty",
      key: "qty",
    },
    { label: "Created Date", key: "createdDate" },
  ];
  const csvLink = {
    filename: "Item Status Report.csv",
    headers: headers,
    data: Download,
  };

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
    setSelectedLocation("");
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleLocationChange = (selectedItemCode) => {
    setSelectedLocation(selectedItemCode);
  };

  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = getLocationsReducer.locations
      ? getLocationsReducer.locations
      : [];
    data.map((item) => {
      tempItemCodeOptions.push({
        label: item.locationName,
        value: item.locationId,
      });
    });
    setLocationOptions(tempItemCodeOptions);
  }, [getLocationsReducer]);

  const handleItemTypeChange = (selectedOption) => {
    setSelectedItemType(selectedOption);
    setSelectedItemCode("");
    setSelectedLocation("");
    getItemTypesForStatus(jwtToken);
  };
  const itemTypeOptions = [
    { label: "Rejection", value: "REJ" },
    { label: "Quarantine", value: "QA" },
    { label: "RTV", value: "RTV" },
    { label: "Scrap", value: "SCRAP" },
  ];

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // let isoStartDate;
  // let isoEndDate;
  // useEffect(() => {
  //   if (startDate || endDate) {
  //     isoStartDate = new Date(
  //       (startDate ? startDate : new Date()).getTime() -
  //         (startDate ? startDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formatDate = (date) => {
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const formattedStartDate = formatDate(new Date(isoStartDate));

  //     isoEndDate = new Date(
  //       (endDate ? endDate : new Date()).getTime() -
  //         (endDate ? endDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formattedEndDate = formatDate(new Date(isoEndDate));
  //   }
  //   // Now you can use both formattedStartDate and formattedEndDate
  //   getMinMaxFailure(
  //     isoStartDate ? isoStartDate : "",
  //     isoEndDate ? isoEndDate : "",
  //     selectedItemCode?.value ? selectedItemCode?.value : "",
  //     jwtToken
  //   );
  //   // useEffect(() => {
  //   //   getMinMaxFailure(
  //   //     pageNo,
  //   //     rowsPerPage,
  //   //     searchObject,
  //   //     isoStartDate ? isoStartDate.value : "",
  //   //     isoEndDate ? isoEndDate.value : "",
  //   //     selectedItemCode ? selectedItemCode.value : "",
  //   //     jwtToken
  //   //   );
  //   // }, [pageNo, rowsPerPage, searchObject, startDate, endDate,selectedItemCode]);
  // }, [startDate, endDate, selectedItemCode]);

  // useEffect(() => {
  //   let isoStartDate = "";
  //   let isoEndDate = "";

  //   // Only reformat the dates if startDate or endDate are available
  //   if (startDate || endDate) {
  //     isoStartDate = new Date(
  //       (startDate ? startDate : new Date()).getTime() -
  //         (startDate ? startDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formatDate = (date) => {
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const formattedStartDate = formatDate(new Date(isoStartDate));

  //     isoEndDate = new Date(
  //       (endDate ? endDate : new Date()).getTime() -
  //         (endDate ? endDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formattedEndDate = formatDate(new Date(isoEndDate));
  //   }

  //   // Ensure pagination-related changes are handled properly
  //   getMinMaxFailure(
  //     pageNo,
  //     rowsPerPage,
  //     searchObject,
  //     isoStartDate ? isoStartDate : "",
  //     isoEndDate ? isoEndDate : "",
  //     selectedItemCode ? selectedItemCode.value : "",
  //     jwtToken
  //   );
  // }, [pageNo, rowsPerPage, searchObject, startDate, endDate, selectedItemCode]);

  const [isoStartDate, setIsoStartDate] = useState("");
  const [isoEndDate, setIsoEndDate] = useState("");

  useEffect(() => {
    let isoStart = "";
    let isoEnd = "";

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    if (startDate) {
      isoStart = new Date(
        startDate.getTime() - startDate.getTimezoneOffset() * 60000,
      ).toISOString();
      setIsoStartDate(isoStart); // Optional: only if you need the state elsewhere
    } else {
      setIsoStartDate("");
    }

    if (endDate) {
      isoEnd = new Date(
        endDate.getTime() - endDate.getTimezoneOffset() * 60000,
      ).toISOString();
      setIsoEndDate(isoEnd); // Optional: only if you need the state elsewhere
    } else {
      setIsoEndDate("");
    }

    // Now call API with local values directly
    getMinMaxFailure(
      pageNo,
      rowsPerPage,
      searchObject,
      isoStart || "", // use freshly computed values
      isoEnd || "",
      selectedItemCode ? selectedItemCode.value : "",
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, startDate, endDate, selectedItemCode]);

  // You can now access isoStartDate and isoEndDate anywhere in this component

  const [selectedDateRange, setSelectedDateRange] = useState("");

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };

  const [customDate, setCustomDate] = useState("");
  const sevenDays = subDays(new Date(), 7).toISOString();
  const thityDays = subDays(new Date(), 30).toISOString();
  const nintyDays = subDays(new Date(), 90).toISOString();

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDateDownload, endDateDownload] = dateRange;

  // useEffect(() => {
  //   getDateRange(jwtToken);
  // }, []);

  useEffect(() => {
    if (selectedDateRange.value == 7) {
      setCustomDate(sevenDays);
    }
    if (selectedDateRange.value == 30) {
      setCustomDate(thityDays);
    }
    if (selectedDateRange.value == 90) {
      setCustomDate(nintyDays);
    }
  }, [selectedDateRange]);

  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];
  useEffect(() => {
    downloadMinMaxFailure(
      dateRange[1] !== null
        ? addDays(dateRange[1], 1)?.toISOString()
        : new Date().toISOString(),
      dateRange[0] !== null
        ? addDays(dateRange[0], 1)?.toISOString()
        : customDate,
      pageNo,
      rowsPerPage,
      searchObject,
      isoStartDate ? isoStartDate : "",
      isoEndDate ? isoEndDate : "",
      selectedItemCode ? selectedItemCode.value : "",
      jwtToken,
    );
  }, [customDate, dateRange, startDate, endDate, selectedItemCode]);

  const subModuleId = "95815117-55fd-40be-ab8f-a9407d9ae1df";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getMinMaxFailure(
        pageNo,
        rowsPerPage,
        searchObject,
        isoStartDate ? isoStartDate : "",
        isoEndDate ? isoEndDate : "",
        selectedItemCode ? selectedItemCode.value : "",
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  //   const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-4}
              >
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} lg={8}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      mt={2}
                    >
                      <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Date Range
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                        //   options={itemTypeOptions}
                          value={selectedItemType}
                          onChange={handleItemTypeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Item Code
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                        //   options={itemCodeOptions}
                          value={selectedItemCode}
                          onChange={handleItemCodeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Picklist Qty
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                        //   options={locationOptions}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        />
                      </MDBox>
                      <MDBox
                        display="flex"
                        alignItems="center"
                        marginLeft={1}
                        marginTop={{ xs: 2, lg: 3 }}
                      >
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            style={{ marginLeft: "5px" }}
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    </MDBox>
                  </Grid> */}
                  <Modal
                    open={openCreateColumnReorderModal}
                    onClose={handleCloseCreateColumnReorderModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <MDCard sx={styleForColumnReorder}>
                      <MDTypography>
                        Are you sure you want to submit?
                      </MDTypography>
                      <MDBox mt={2}>
                        <MDButton
                          style={{ width: "10rem", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseCreateColumnReorderModal}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          style={{ width: "10rem", marginLeft: "0.5rem" }}
                          color="success"
                          onClick={handleDynamicColumn}
                          // disabled={denyButtonName === "Please wait..."}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                      <MDBox mt={2}>
                        <Collapse in={isSuccessColumnReorder}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessColumnReorder(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Data updated successfully!
                          </Alert>
                        </Collapse>
                        <Collapse in={isErrorColumnReorder}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorColumnReorder(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {isErrorMsgForColumnReorder}
                          </Alert>
                        </Collapse>
                      </MDBox>
                    </MDCard>
                  </Modal>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      mt={2}
                    >
                      <MDBox
                        display="flex"
                        flexDirection="row"
                        width={{ xs: "auto", lg: "400px" }} // Adjust width as needed
                        style={{ marginRight: "5px" }}
                      >
                        <div>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Start Date
                          </MDTypography>
                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Start Date"
                            maxDate={new Date()}
                            onChange={(date) => {
                              if (date === null && endDate) {
                                setErrorMessage("Please clear the end date");
                                setTimeout(() => setErrorMessage(""), 3000); // Auto clear after 3 seconds
                                return;
                              }
                              setStartDate(date);

                              // Optional: Clear end date if it's before the new start
                              if (endDate && date && endDate < date) {
                                setEndDate(null);
                              }
                            }}
                            isClearable={true}
                            selectsStart
                            selected={startDate}
                            startDate={startDate}
                            endDate={endDate}
                          />{" "}
                          {errorMessage && (
                            <MDTypography
                              variant="body2" // larger than caption
                              color="error"
                              style={{ marginTop: "4px", display: "block" }}
                            >
                              {errorMessage}
                            </MDTypography>
                          )}
                        </div>
                        <div style={{ marginLeft: "4px" }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            End Date
                          </MDTypography>
                          <DatePicker
                            className={`form-control ${!startDate ? "datepicker-disabled" : ""}`}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="End Date"
                            maxDate={new Date()}
                            onChange={(date) => setEndDate(date)}
                            isClearable={true}
                            // withPortal
                            selectsEnd
                            selected={endDate}
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            disabled={!startDate}
                          />
                        </div>
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "500px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Item Code
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          options={itemCodeOptions}
                          value={selectedItemCode}
                          onChange={handleItemCodeChange}
                        />
                      </MDBox>
                      <Grid>
                        <MDBox
                          color="text"
                          px={0}
                          display="flex"
                          flexDirection="column"
                        >
                          <MDBox
                            display="flex"
                            marginLeft={1}
                            marginTop="1.5rem"
                          >
                            {/* <CSVLink> */}
                            <Tooltip title="Download All Data">
                              <MDButton
                                type="button"
                                variant="outlined"
                                color="success"
                                iconOnly
                                style={{ borderRadius: "5px" }}
                                size="small"
                                onClick={handleCreateCircularModal}
                              >
                                <Icon>download</Icon>
                              </MDButton>
                            </Tooltip>
                            {/* </CSVLink> */}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Modal
                        open={createCircularModal}
                        onClose={handleCreateCloseCircularModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <MDCard sx={style} style={{ zIndex: 0 }}>
                          <MDBox
                            ml={3}
                            mt={-1}
                            display="flex"
                            alignItems="center"
                          >
                            <MDTypography
                              variant="h5"
                              fontWeight="medium"
                              flexGrow={1}
                            >
                              Download Report
                            </MDTypography>
                            <MDBox>
                              <Tooltip title="Close">
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  onClick={handleCreateCloseCircularModal}
                                  style={{
                                    background: "whitesmoke",
                                    color: "black",
                                    borderRadius: 5,
                                    marginLeft: "-55px",
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </Tooltip>
                            </MDBox>
                          </MDBox>
                          <hr
                            style={{
                              marginTop: "0.5rem",
                              marginBottom: "1rem",
                            }}
                          />

                          <MDBox pt={1} pb={3} px={3}>
                            {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                            <MDBox
                              style={{
                                marginRight: "5px",
                                marginBottom: "10px",
                              }}
                            >
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: 500 }}
                              >
                                Date Range
                              </MDTypography>
                              <Select
                                // isClearable
                                placeholder="Choose One..."
                                className="select-css-for-filter"
                                maxMenuHeight={130}
                                options={dateRangeOptions}
                                value={selectedDateRange}
                                onChange={handleDateRangeChange}
                              />
                            </MDBox>
                            {selectedDateRange?.value ===
                              "Custom date Range" && (
                              <MDBox
                                // width={{ xs: "125px", lg: "700px" }}
                                style={{ marginRight: "5px" }}
                              >
                                <MDTypography variant="h6">
                                  Custom Date Range
                                </MDTypography>

                                <DatePicker
                                  className="form-control"
                                  dateFormat="dd/MM/yyyy"
                                  placeholderText="Select date range"
                                  onChange={(date) => setDateRange(date)}
                                  isClearable={true}
                                  startDate={startDateDownload}
                                  endDate={endDateDownload}
                                  selectsRange={true}
                                  popperPlacement="right-end"

                                  // withPortal
                                />

                                {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                              </MDBox>
                            )}
                            {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}
                            <MDBox mt={3}>
                              {((selectedDateRange?.value ===
                                "Custom date Range" &&
                                dateRange[0] !== null) ||
                                selectedDateRange) &&
                                Download.length < 1 && (
                                  <TextError msg="No data found" />
                                )}
                              {(selectedDateRange?.value ===
                                "Custom date Range" &&
                                dateRange[0] === null) ||
                              Download.length < 1 ||
                              !selectedDateRange ? (
                                <MDButton
                                  color="success"
                                  fullWidth
                                  type="button"
                                  disabled
                                >
                                  Submit
                                </MDButton>
                              ) : (
                                <CSVLink
                                  {...csvLink}
                                  onClick={() => {
                                    // Close modal after 2 seconds
                                    setTimeout(() => {
                                      handleCreateCloseCircularModal();
                                    }, 1000); // 2000ms = 2 seconds
                                  }}
                                >
                                  <MDButton
                                    color="success"
                                    fullWidth
                                    type="button"
                                  >
                                    Submit
                                  </MDButton>
                                </CSVLink>
                              )}
                            </MDBox>
                          </MDBox>
                          {/* </MDBox> */}
                        </MDCard>
                      </Modal>

                      {/* <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Picklist Qty
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        />
                      </MDBox> */}
                      {/* <MDBox
        width={{ xs: "125px", lg: "200px" }}
        style={{ marginRight: "5px" }}
      >
        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
          Success Rate
        </MDTypography>
        <Select
          isClearable
          placeholder="Choose One..."
          className="select-css-for-filter"
          maxMenuHeight={130}
          value={selectedLocation}
          onChange={handleLocationChange}
        />
      </MDBox> */}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  // <DataTable
                  //   table={{ columns, rows }}
                  //   isSorted={true}
                  //   tableSearch={true}
                  //   entriesPerPage={{
                  //     defaultValue: 5,
                  //     entries: [5, 10, 15, 20, 25, 30],
                  //   }}
                  //   showTotalEntries={true}
                  //   noEndBorder
                  //   loading={loading}

                  // paginationObj={paginationObj}
                  //   hideColumns={hiddenColumsDetails}
                  //     pageNoProp={importPageNo}
                  // rowsPerPageProp={importRowsPerPage}
                  // searchProp={importSearch}
                  //   visibleColumns2={dynamicColumnData?.visibleFields}
                  //   dynamicColumnData={dynamicColumnData}
                  //   handleOpenCreateColumnReorderModal={
                  //     handleOpenCreateColumnReorderModal
                  //   }
                  //   subModuleId={subModuleId}
                  //   userId={userId}
                  // />
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ToastContainer />
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getItemTypeReducer: state.getItemTypeReducer,
    getLocationsReducer: state.getLocationsReducer,
    getItemStatusReducer: state.getItemStatusReducer,
    getMinMaxFailureReducer: state.getMinMaxFailureReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
    downloadMinMaxFailureReportReducer:
      state.downloadMinMaxFailureReportReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getItemTypesForStatus: (jwtToken) =>
      dispatch(getItemTypesForStatus(jwtToken)),
    getLocations: (jwtToken) => dispatch(getLocations(jwtToken)),
    getItemStatus: (
      selectedItemType,
      selectedItemCode,
      selectedLocation,
      jwtToken,
    ) =>
      dispatch(
        getItemStatus(
          selectedItemType,
          selectedItemCode,
          selectedLocation,
          jwtToken,
        ),
      ),
    // getMinMaxFailure: (isoStartDate, isoEndDate, selectedItemCode, jwtToken) =>
    //   dispatch(
    //     getMinMaxFailure(isoStartDate, isoEndDate, selectedItemCode, jwtToken)
    //   ),
    getMinMaxFailure: (
      pageNo,
      rowsPerPage,
      searchObject,
      isoStartDate,
      isoEndDate,
      selectedItemCode,
      jwtToken,
    ) =>
      dispatch(
        getMinMaxFailure(
          pageNo,
          rowsPerPage,
          searchObject,
          isoStartDate,
          isoEndDate,
          selectedItemCode,
          jwtToken,
        ),
      ),
    downloadMinMaxFailure: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      isoStartDate,
      isoEndDate,
      selectedItemCode,
      jwtToken,
    ) =>
      dispatch(
        downloadMinMaxFailure(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          isoStartDate,
          isoEndDate,
          selectedItemCode,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(MinMaxFailure);
